export default __webpack_public_path__ + "locales/pt/PDFFormDialog.json?hash=9423fb165314da107632cf68de59e238";